module.exports = __webpack_public_path__ + "media/subway/C-5eaacaad.png";